// Desktop uses two columns: animate existing cards between their actual slots.
// Mobile keeps its CSS height transitions and does not run this layout pass.
export const createTagLayoutMotion = (group) => {
  let animations = []
  let ghosts = []

  const cancel = () => {
    animations.forEach((animation) => {
      animation.onfinish = null
      animation.cancel()
    })
    ghosts.forEach(({ clone }) => clone.remove())
    animations = []
    ghosts = []
  }

  const toggle = (update) => {
    const entries = Array.from(group.children).filter(
      (node) => !node.hasAttribute('data-motion-ghost')
    )
    const before = new Map()
    const startHeight = group.getBoundingClientRect().height
    entries.forEach((node) => {
      if (getComputedStyle(node).display !== 'none') {
        before.set(node, {
          rect: node.getBoundingClientRect(),
          opacity: getComputedStyle(node).opacity,
        })
      }
    })
    // A quick reversal can bring back an item that is still fading out.
    ghosts.forEach(({ node, clone }) => {
      if (!before.has(node))
        before.set(node, {
          rect: clone.getBoundingClientRect(),
          opacity: getComputedStyle(clone).opacity,
        })
    })
    cancel()
    update()
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !group.animate
    )
      return

    const bounds = group.getBoundingClientRect()
    const endHeight = bounds.height
    const timing = { duration: 520, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    const animate = (node, frames, options = timing) => {
      const animation = node.animate(frames, options)
      animations.push(animation)
      return animation
    }

    entries.forEach((node) => {
      const previous = before.get(node)
      if (getComputedStyle(node).display === 'none') {
        if (!previous) return
        const clone = node.cloneNode(true)
        clone.setAttribute('data-motion-ghost', '')
        clone.setAttribute('aria-hidden', 'true')
        clone.setAttribute('inert', '')
        Object.assign(clone.style, {
          display: 'block',
          position: 'absolute',
          pointerEvents: 'none',
          margin: '0',
          left: `${previous.rect.left - bounds.left}px`,
          top: `${previous.rect.top - bounds.top}px`,
          width: `${previous.rect.width}px`,
          height: `${previous.rect.height}px`,
        })
        group.appendChild(clone)
        ghosts.push({ node, clone })
        animate(clone, [{ opacity: previous.opacity }, { opacity: 0 }], {
          duration: 140,
          easing: 'ease-out',
          fill: 'forwards',
        })
        return
      }
      const next = node.getBoundingClientRect()
      if (previous) {
        animate(node, [
          {
            transform: `translate(${previous.rect.left - next.left}px, ${
              previous.rect.top - next.top
            }px)`,
            opacity: previous.opacity,
          },
          { transform: 'translate(0, 0)', opacity: 1 },
        ])
      } else {
        animate(node, [{ opacity: 0 }, { opacity: 1 }], {
          duration: 280,
          delay: 100,
          easing: 'ease-out',
          fill: 'backwards',
        })
      }
    })
    const layout = animate(group, [
      { height: `${startHeight}px` },
      { height: `${endHeight}px` },
    ])
    layout.id = 'section-layout'
    layout.onfinish = cancel
  }

  return { toggle, cancel }
}
